
























import Vue from "vue";
import Navbar from "@/components/ui/Navbar.vue";
import api, { handleError } from "@/lib/api";
export default Vue.extend({
	components: {
		Navbar,
	},
	data() {
		return {
			reservations: [],
            ok: [] as any[],
            message: ''
        };
	},
    methods: {
        graphicReserve(reservation: any){
            
            reservation.reserved = !reservation.reserved;      
            if(reservation.reserved) this.ok.push(reservation);     
            else this.ok.splice(this.ok.indexOf(reservation), 1);

        },
        async sendReservations(){

            const stringified = this.ok.map(reservation => reservation.id.toString()).join(",");
            
            try{

                await api.monks.sendReservations(stringified);
                this.message = "Messaggi inviati!"

            }catch(err){

                this.message = handleError(err);

            }
            
        }
    },
	async mounted() {
		try {
            
            this.reservations = await api.monks.getAllReservations();
            
		} catch (err) {
			alert(handleError(err));
        }
	},
});
